import { IConclusion } from '../app/resource/conclusion/conclusion.types';
import { ISession } from '../app/resource/session/session.types';
import { IUser } from '../app/resource/user/user.types';

export const RECAP_VALIDATION_ERROR_MESSAGE =
  'Each meeting member must have a score or be marked as did not attend before finishing.';
export const RECAP_NO_SCORE_ERROR_MESSAGE = 'At least one member must have a score before finishing the meeting.';

export const VALID_RECAP_SCORES = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
const validRecapScoresSet = new Set(VALID_RECAP_SCORES);

export const hasValidRecapScore = (score: string | null | undefined): boolean =>
  score !== null && score !== undefined && validRecapScoresSet.has(String(score).trim());

export const isUserRecapComplete = (
  userId: IUser['id'],
  sessionId: ISession['id'],
  conclusions: IConclusion[],
  notAttendedIds: IUser['id'][],
): boolean => {
  if (notAttendedIds.includes(userId)) {
    return true;
  }

  const userConclusion = conclusions.find(
    (conclusion) => conclusion.sessionId === sessionId && conclusion.userId === userId,
  );
  return hasValidRecapScore(userConclusion?.score);
};

export const getIncompleteRecapUserIds = (
  userIds: IUser['id'][],
  sessionId: ISession['id'],
  conclusions: IConclusion[],
  notAttendedIds: IUser['id'][],
): IUser['id'][] => userIds.filter((userId) => !isUserRecapComplete(userId, sessionId, conclusions, notAttendedIds));

export const hasAtLeastOneScoredMember = (
  userIds: IUser['id'][],
  sessionId: ISession['id'],
  conclusions: IConclusion[],
): boolean =>
  userIds.some((userId) => {
    const userConclusion = conclusions.find(
      (conclusion) => conclusion.sessionId === sessionId && conclusion.userId === userId,
    );

    return hasValidRecapScore(userConclusion?.score);
  });
